import axiosClient from './base'

// Get user Hash for Front App chat widget
export const getUserHash = () => axiosClient.get('/api/users/frontapp-hash')
